const FUNDAMENTAL_TRENDS_URL =
  "https://raw.githubusercontent.com/aport550/majorah-data/main/public/data/fundamental_trends.json";

// If your app serves this file locally from public/data, use this instead:
// const FUNDAMENTAL_TRENDS_URL = "/data/fundamental_trends.json";

export async function fetchFundamentalTrends() {
  const res = await fetch(FUNDAMENTAL_TRENDS_URL, {
    cache: "no-store",
  });

  if (!res.ok) {
    throw new Error(`Failed to fetch fundamental trends: ${res.status}`);
  }

  return res.json();
}

export function normalizeTicker(value) {
  return String(value || "")
    .trim()
    .toUpperCase();
}

export function getFundamentalTrendForTicker(data, ticker) {
  if (!data || !data.stocks) return null;
  return data.stocks[normalizeTicker(ticker)] || null;
}

export function mergeFundamentalTrendsIntoRows(rows, data, tickerField = "ticker") {
  if (!Array.isArray(rows)) return [];

  return rows.map((row) => {
    const ticker = normalizeTicker(row?.[tickerField] ?? row?.Ticker ?? row?.ticker);
    const f = getFundamentalTrendForTicker(data, ticker);

    return {
      ...row,
      tamScore: f?.tamScore ?? null,
      moatScore: f?.moatScore ?? null,
      operatingMarginTrendScore: f?.operatingMarginTrendScore ?? null,
      grossMarginTrendScore: f?.grossMarginTrendScore ?? null,
      moatSource: f?.moatSource ?? null,
      fundamentalTrendError: f?.error ?? null,
      fundamentalRevenue: f?.revenue ?? null,
      fundamentalOperatingMargin: f?.operatingMargin ?? null,
      fundamentalGrossMargin: f?.grossMargin ?? null,
    };
  });
}